import { renderHeader } from "../components/Header"
import { renderFooter } from "../components/Footer"
import { fetchStickers } from "../api/StickersAPI"
import { renderStickerCard } from "../components/StickerCard"

export async function renderHomePage(root: HTMLElement) {

  root.innerHTML = ""

  

  const main = document.createElement("main")
  main.className = "landing-main"

  main.innerHTML = `



<section class="hero">

  <div class="hero-top">

    <img src="img/logo.png" class="hero-logo" alt="DeutschBezBolu">

      <div class="login-block">
      
      <a class="login-button" href="https://app.deutsch.bezbolu.pro">
        Увійти
      </a>
      </div>

  </div>

  <h1>
    Вивчайте німецьку без “каші в голові”
  </h1>

  <p class="hero-subtitle">
    Зрозуміла граматика українською мовою + вправи після кожного кроку.<br>
    Рівень A2–B1 · 15–20 хвилин на день
  </p>

  <a href="#pricing" class="hero-button">
    Почати вже сьогодні
  </a>

</section>

<section class="landing-block">
 <div class="section-card">

    <h2>Вам знайоме це?</h2>

    <ul>
    <li>Ви вивчаєте німецьку 2–3 роки, можливо навіть склали A2, але все ще плутаєтеся у відмінюванні, підрядних реченнях, прийменниках, артиклях</li>
    <li>Пояснення німецькою тільки заплутують</li>
    <li>В голові каша замість системи</li>
    </ul>

    <p><strong>Головна проблема:</strong></p>

    <p>
    Ви не бачите структури мови.  
    Ви не розумієте логіку.  
    Вам ніхто не пояснив, ЧОМУ треба саме так.
    </p>


    <h2>Саме тому ми створили застосунок з іншою методикою</h2>

    <ul>
    <li> Вся граматика пояснюється українською</li>
    <li> Купа прикладів з перекладом</li>
    <li> Кожна тема розбита на маленькі логічні кроки</li>
    <li> Після кожного кроку — вправи</li>
    </ul>

    <p>
    Ви не просто виконуєте завдання.  
    Ви починаєте розуміти, як працює німецька мова.
    </p>
      <div class="card-cta">
        <a href="#pricing" class="cta-button">
        Хочу почати заняття
        </a>
      </div>
  </div>
</section>


<section class="landing-block">
    <div class="section-card">

    <h2>Як це працює</h2>

    <p><strong>Принцип 1–2 кроки на день</strong></p>

    <p>
    Ви можете вибрати програму «Стандарт» (1 крок щодня)
    або «Інтенсив» (2 кроки щодня).
    </p>

    <p>
    Маленькі порції інформації краще засвоюються.
    </p>

    <p>
    Кроки не згорають — ви проходите їх тоді, коли знайдете час.
    </p>

    <p>
    Заняття займають приблизно 15–20 хвилин.
    </p>

    <p>
    Можна займатися на телефоні, планшеті або комп’ютері.
    </p>
    <div class="card-cta">
    <a href="#pricing" class="cta-button">
    Хочу почати заняття
    </a>
    </div>

  </div>
</section>


<section class="landing-block">
  <div class="section-card">

    <h2>Що входить у програму</h2>

    <p>
    Вся граматика рівнів A2–B1.
    </p>

    <p>
    Ми не ділимо матеріал жорстко за рівнями,
    тому що в граматиці ці межі дуже умовні.
    </p>

    <p>
    Матеріал подається логічно і послідовно.
    </p>

    <p>
    Кожна тема супроводжується вправами.
    </p>



    <h2>Чим ми відрізняємось від інших застосунків</h2>

    <ol>

    <li>
    Продумана структура подачі матеріалу
    </li>

    <li>
    Зрозумілі пояснення
    </li>

    <li>
    Розумні вправи без вгадування
    </li>

    </ol>
    <div class="card-cta">
    <a href="#pricing" class="cta-button">
    Хочу на заняття
    </a>
    </div>

  </div>

</section>


<section id="pricing" class="pricing">

<h2>Підписка</h2>

<div id="stickers">
Завантаження тарифів...
</div>

</section>

`

  root.appendChild(main)

  root.appendChild(renderFooter())

  try {

    const stickers = await fetchStickers()

    const container = document.getElementById("stickers")!

    container.innerHTML = ""

    stickers
      .sort((a,b) => a.priority - b.priority)
      .forEach(sticker => {

        container.appendChild(
          renderStickerCard(sticker)
        )

      })

  } catch {

    const container = document.getElementById("stickers")!

    container.innerHTML = "Не вдалося завантажити тарифи"

  }

}